import { api } from '@/lib/api';

export type BugReportPayload = {
  email: string;
  description: string;
  screenshotUrl?: string | null;
  pageUrl?: string | null;
};

export const supportApi = {
  uploadBugReportScreenshot: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.upload<{ url: string }>('/support/bug-report/screenshot', formData);
  },

  sendBugReport: (payload: BugReportPayload) =>
    api.post<{ success: boolean }>('/support/bug-report', payload),
};
